// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._1hms8stv{text-decoration-line:underline}
._4bfu1r31{text-decoration-color:currentColor}
._ajmmnqa1{text-decoration-style:solid}
._vchhusvi{box-sizing:border-box}`, "",{"version":3,"sources":["webpack://./node_modules/@atlaskit/primitives/dist/esm/compiled/components/anchor.compiled.css"],"names":[],"mappings":"AAAA,WAAW,8BAA8B;AACzC,WAAW,kCAAkC;AAC7C,WAAW,2BAA2B;AACtC,WAAW,qBAAqB","sourcesContent":["._1hms8stv{text-decoration-line:underline}\n._4bfu1r31{text-decoration-color:currentColor}\n._ajmmnqa1{text-decoration-style:solid}\n._vchhusvi{box-sizing:border-box}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
